module.exports = __webpack_public_path__ + "static/media/NavServicesIcon.4cf35c8e.svg";